import React, {useState} from 'react';
import { Form, Input, Button, Icon, Checkbox, message, Select, Alert } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Text3 } from '../../../../styles';
import { SmartCollectDisbursements, SmartCollectTransaction } from '../../../../models';
import { alertify, printRupee } from '../../../../app_methods';


let SmartCollectRefundForm = (props) => {
    const [disabledFields, setDisabledFields] = useState({
        "NEFT": false,
        "IMPS": false,
        "RTGS": true,
        "UPI": false
    });
    const { form, transaction } = props;
    const { getFieldDecorator } = form;
    const validations = SmartCollectTransaction.validations;
    const disbursementsValidations = SmartCollectDisbursements.validations;

    const handleAmountChange = (e) => {
        const amount = parseFloat(e.target.value);
        if (isNaN(amount)) return;
        let _disabledFields = { ...disabledFields };
        _disabledFields["NEFT"] = amount < 1;
        _disabledFields["IMPS"] = amount < 1 || amount > 500000;
        _disabledFields["RTGS"] = amount < 200000;
        _disabledFields["UPI"] = amount < 1 || amount > 100000;
        setDisabledFields(_disabledFields);
        if (props.form.getFieldValue("payment_mode") == "RTGS" && amount <= 500000) props.form.setFieldsValue({ payment_mode: "IMPS" });
        else if (props.form.getFieldValue("payment_mode") == "IMPS" && amount > 500000) props.form.setFieldsValue({ payment_mode: "RTGS" });
    };

    const paymentModeOptions = transaction.payment_mode == "UPI" ? ["UPI"] : ["IMPS", "NEFT", "RTGS"];

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            const amount = form.getFieldValue('amount');
            if(amount > transaction.refundable_amount){
                alertify("Oops!!!", `Refund amount must not exceed the transaction amount. Maximum allowed refund amount for this transaction is ${transaction.refundable_amount}`, "error");
                return
            }
            props.onSubmit(form.getFieldsValue());
        });
    };

    const renderBasicForm = () => {
        return (
            <div>
                <div>
                    {getFieldDecorator("id", {
                        initialValue: transaction.id,
                        rules: validations.id
                    })(<Input autoComplete='off' hidden />)}

                    <Form.Item label="Amount">
                        {getFieldDecorator("amount", {
                            initialValue: (transaction && (transaction.refundable_amount || 0).toFixed(2).toString()) || "",
                            rules: disbursementsValidations.amount
                        })(<Input autoComplete='off' onChange={handleAmountChange}/>)}
                    </Form.Item>
                    <Form.Item label="Payment Mode">
                        {getFieldDecorator("payment_mode", {
                            initialValue: paymentModeOptions[0],
                            rules: [{ required: true, message: "Please select payment mode." }]
                        })(
                            <Select>
                                {
                                    paymentModeOptions.map(mode =>
                                        <Select.Option value={mode} disabled={disabledFields[mode]}>{mode}</Select.Option>
                                    )
                                }
                            </Select>
                        )}
                    </Form.Item>
                    {form.getFieldValue('payment_mode') === 'RTGS'?
                        <Alert
                            className="mb-2"
                            type="info"
                            message="Working hours for RTGS are 8:30 am to 5:45 pm. Any transaction after 5:45 pm would be processed on next working day."
                            icon={<Icon type="info-circle" />}
                            showIcon
                        /> : null
                    }
                </div>
            </div>
        )
    };

    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm">{renderBasicForm()}</div>
            </div>
            <div className="row">
                <div className="col-sm">
                    <div className="font-weight-bold" style={{color: "#58666e"}}>Note:</div>
                    <i>Refund would be credited to the source account.</i>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Submit</Button>
            </div>
        </Form>
    )
};

SmartCollectRefundForm = Form.create()(SmartCollectRefundForm);
export { SmartCollectRefundForm };